import { Component, inject, ViewEncapsulation } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  templateUrl: './terms-of-use.component.html',
  styleUrl: './terms-of-use.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslatePipe,
    RouterLink,
    CommonModule
  ]
})
export class TermsOfUseComponent {
  effectiveDate = '2025-07-21';
  constructor(public translateService: TranslateService) {}
}
